"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOrganization = exports.getOrganization = exports.setUser = exports.getUser = void 0;
var user;
var organization;
function getUser() {
    return user;
}
exports.getUser = getUser;
function setUser(userToSet) {
    user = userToSet;
}
exports.setUser = setUser;
function getOrganization() {
    return organization;
}
exports.getOrganization = getOrganization;
function setOrganization(organizationToSet) {
    organization = organizationToSet;
}
exports.setOrganization = setOrganization;
